import * as React from "react";

import "./cart-processing-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {Interval}       from "@Common/react/interval";
import {Invoke}         from "@Common/react/invoke";
import {UseState}       from "@Common/react/use-state";

export const CartProcessingModal = ({cart, next: rootNext}) => cs(
    ["state", (_, next) => UseState({
        // initValue: {},
        next,
    })],
    ["rootCart", (_, next) => cs(
        consumeContext("cart"),
        ({cart}) => next(cart),
    )],
    ({state}, next) => fragments(
        rootNext({
            show: () => state.onChange({}),
            hide: () => state.onChange(null),
        }),
        state.value && next(),
    ),
    ["processing", (_, next) => UseState({next})],
    ({state, processing}) => fragments(
        cart.value.status === "processing" && Invoke({
            action: () => processing.onChange(true),
        }),

        processing.value && cart.value.status === "pending" && Invoke({
            action: () => {
                alert("Cart processing failed, orders have been returned to pending. Please try again.");
                state.onChange(null);
            },
        }),

        Interval({
            delay: 3000,
            fn: async () => {
                await cart.reload();
            },
        }),
        (
            <div className="cart-processing-modal cart-processing-modal-3uh">
                <div className="overlay">
                    <div className="message">
                        Current cart is processing, please wait until cart has completed checkout.
                    </div>
                </div>
            </div>
        ),
    )
);

